import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { ModalFooter } from '@atlaskit/modal-dialog';
import { ButtonGroup } from '@atlaskit/button';
import Button from '@atlaskit/button/new';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { ANALYTICS_SOURCE } from '../page/RolesManagementView';

import type { DeletionResultSelectionType } from './DeleteRoleModal';

export const DeleteRoleFooter = ({
	deletionResult,
	onClose,
	onCancel,
}: {
	deletionResult: DeletionResultSelectionType;
	onClose: () => void;
	onCancel: () => void;
}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onConfirm = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: ANALYTICS_SOURCE,
				actionSubject: 'button',
				action: 'clicked',
				actionSubjectId: 'confirmRolePermissionsDelete',
				attributes: {
					resultChoice: deletionResult,
				},
			},
		}).fire();
		onClose();
	}, [createAnalyticsEvent, deletionResult, onClose]);

	return (
		<ModalFooter>
			<ButtonGroup>
				<Button appearance="subtle" onClick={onCancel}>
					<FormattedMessage
						id="default-space-permissions.roles-management.delete-role-modal.cancel-button"
						defaultMessage="Cancel"
						description="Label for a button to cancel the deletion of a custom role"
					/>
				</Button>
				<Button appearance={deletionResult === 'delete' ? 'danger' : 'primary'} onClick={onConfirm}>
					{deletionResult === 'delete' ? (
						<FormattedMessage
							id="default-space-permissions.roles-management.delete-role-modal.delete-option-confirm"
							defaultMessage="Delete and remove"
							description="Label for a confirmation button to delete a role and remove user access"
						/>
					) : (
						<FormattedMessage
							id="default-space-permissions.roles-management.delete-role-modal.reassign-option-confirm"
							defaultMessage="Delete and reassign"
							description="Label for a confirmation button to delete a role and reassign users"
						/>
					)}
				</Button>
			</ButtonGroup>
		</ModalFooter>
	);
};
